'use client'
import React from 'react';
import TestamonialCard from '@components/TestamonialCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import LinkComponent from '@components/LinkComponent';
import 'swiper/css';
import 'swiper/css/navigation';


const TestamonialCardSlider = ({ title, description, testamonials, moreUrl = '', dictionary, lang, params }) => {
    return (
    <div className='w-full'>
        <div className='w-full flex flex-col my-4 pl-2 md:pl-0'>
            <h2 className='text-maincolor text-2xl font-bold'>{title}</h2>
            <p className='text-maincolor text-xl mb-2'>{description}</p>
            {testamonials.length > 0 && (
                <div className='sm:block hidden'>
                    <Swiper
                        // slidesPerView={'auto'}
                        spaceBetween={10}
                        slidesPerView={4}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[Navigation]}
                        className=''
                    >
                        {testamonials.map((testamonial, index) => (
                            <SwiperSlide key={index}>
                                <TestamonialCard about={true} testamonial={testamonial} dictionary={dictionary} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
            {testamonials.length > 0 && (
                <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.2}
                    >
                        {testamonials.map((testamonial, index) => (
                            <SwiperSlide key={index}>
                                <TestamonialCard testamonial={testamonial} dictionary={dictionary} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </div>
    </div>
  )
}

export default TestamonialCardSlider